import {Flex, Text, Button} from "../../../../components";
import React from "react";
import styled from "styled-components";
import moment from '../../../../utils/MomentConst';

const Container = styled(Flex)`
  width: 100%;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
  background: #161930;
  border-radius: 5px;
  padding: 12px 18px;
  margin-bottom: 12px;
`;

const TruncateText = styled(Text.Body)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StatusText = styled(TruncateText)`
  --red: #FF5071;
  --orange: #FFB25C;
  --green: #60FFB0;
  color: var(--${props => props.color || 'green'});
`;

const Cooldown = ({deleteCooldown, data}) => {
  return (
    <Container align='center'>
      <Flex w="20%">
        <TruncateText>{data.owner_discord_id ? data.owner_discord_id : 'N/A'}</TruncateText>
      </Flex>
      <Flex w="20%">
        <TruncateText>{data.key}</TruncateText>
      </Flex>
      <Flex w="20%">
        <TruncateText>{moment(data.boundAt).add(data.Type.unbind_delay, 'days').format('MMMM D, YYYY, HH:MM:SS')}</TruncateText>
      </Flex>
      <Flex fg="1" />
      <Button bg="#FF5071" onClick={() => deleteCooldown(data.id)}>Remove</Button>
    </Container>
  )
}

export default Cooldown;
